import { useEffect, useState, type RefObject } from 'react';

import type { Size } from './canvasMath';

/**
 * Observe a div's size via ResizeObserver. Replaces the window-resize-listener
 * pattern from Fashion Weaver's Canvas — which missed drawer collapses + the
 * agent-bar toggle (the container changed size but the window didn't).
 */
export function useStageSize<T extends HTMLElement>(ref: RefObject<T>): Size {
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });
    observer.observe(el);

    // Seed immediately so the first render doesn't render at (0,0).
    setSize({ width: el.offsetWidth, height: el.offsetHeight });

    return () => observer.disconnect();
  }, [ref]);

  return size;
}
